<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm align-items-center text-sm d-flex justify-content-between catalogo-text"
          >
            {{folio?'Editar':'Registrar'}} producción {{folio?`Folio:${folio}`:''}}
            <router-link :to="{ name: 'Produccion', params: { config: config } }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Fecha:</label>
                <CInput
                  :value.sync="$v.date.$model"
                  :isValid="checkIfValid('date')"
                  type="date"
                  :horizontal="{ input: 'col-sm-12' }"
                  invalidFeedback="Campo requerido"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Cultivo:</label>
                <v-select
                  v-model="cultivo"
                  :options="cultivos"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  @input="getEmbalaje()"
                  placeholder="Selecciona un cultivo"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Embalaje:</label>
                <v-select
                  v-model="embalaje"
                  :options="embalajes"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  placeholder="Selecciona un embalaje"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.cantidad.$model"
                  :isValid="checkIfValid('cantidad')"
                  label="Cantidad:"
                  placeholder="Cantidad"
                  type="number"
                  invalidFeedback="Campo requerido"
                />
              </CCol>
            </CRow>
            <CRow v-if="embalaje && embalaje.type == 'piezas'">
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.peso.$model"
                  :isValid="checkIfValid('peso')"
                  label="Peso (kg.):"
                  placeholder="Peso kg."
                  type="number"
                  invalidFeedback="Campo requerido"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Ubicaciones:</label>
                <div class="d-flex margin-multi align-items-center">
                  <multiselect
                    v-model="multi"
                    :options="ubicaciones"
                    :multiple="true"
                    :loading="isLoadingPage"
                    label="label"
                    track-by="label"
                    placeholder="Selecciona uno o varias ubicaciones"
                    :close-on-select="false"
                    :clear-on-select="false"
                  >
                    <template #no-options>Sin resultados.</template>
                  </multiselect>
                  <transition name="fade">
                    <div v-show="multi && multi.length" @click="cleanMulti()">
                      <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
                    </div>
                  </transition>
                </div>
                <template #no-options>Sin resultados.</template>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CTextarea
                  :value.sync="comentarios"
                  :label="`Comentarios: `"
                  placeholder="Comentarios..."
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <KlayFileDD
                  :fetching="fetching"
                  v-model="medias"
                  :label="`Anexos: `"
                  @onFetch="()=>{fetching=false}"
                  @onErrorFetch="(err)=>{
                    fetching=false;
                    error=err
                    warningModal=true
                  }"
                  :fetchMethod="pushMedia"
                  :baseSrc="$store.getters.MediaGet"
                />
              </CCol>
            </CRow>
            <div class="mask-edit" v-if="folio&&isLoadingPage">
              <div class="w-100 d-flex justify-content-center align-items-center">
                <div class="sk-flow flex align-items-center">
                  <div class="sk-flow-dot bg-load-blue"></div>
                  <div class="sk-flow-dot bg-load-blue"></div>
                  <div class="sk-flow-dot bg-load-blue"></div>
                </div>
              </div>
            </div>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Produccion', params: { config: config } }">
              <CButton class="px-4 mx-3 btn-lg" color="danger">Cancelar</CButton>
            </router-link>

            <CButton v-if="isLoading" class="px-4 mx-3 btn-lg" color="success">
              <div>
                <div class="w-100 d-flex justify-content-center align-items-center">
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
            </CButton>
            <CButton v-else @click="addProduccion()" class="px-4 mx-3 btn-lg" color="success">
              <span>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
      <CModal
        size="sm"
        title="Producción"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
      >{{ error }}</CModal>
      <CModal
        size="sm"
        title="Producción"
        :centered="true"
        color="success"
        :show.sync="successModal"
        >Guardado con éxito.
        <template #footer>
          <CButton @click="closeModal"  color="success">Aceptar</CButton>
        </template>
      </CModal>
    </CRow>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";

export default {
  name: "NuevoProduccion",

  components: {
    Multiselect,
    vSelect
  },

  data() {
    return {
      folio: this.$route.params.folio,
      item:null,
      nanoid: null,
      date: null,
      config: this.$route.params.config,
      cantidad: 1,
      peso: 0,
      cultivos: [],
      cultivo: null,
      cultivosAll: [],
      ubicaciones: [],
      ubicacion: null,
      embalaje: null,
      ubicacionesAll: [],
      multi: null,
      embalajes: [],
      warningModal: false,
      successModal: false,
      isLoading: false,
      isLoadingPage: false,
      currentAlertCounter: 0,
      error: "",
      itemModal: { id: "", name: "" },
      comentarios: '',
      fetching: false,
      medias:[],
    };
  },

  mixins: [validationMixin],
  validations: {
    date: {
      required
    },

    cantidad: {
      required,
      notNegative: (value) => value >= 0
    },
    peso: {
      required,
      notNegative: (value) => value > 0
    },
    ubicacion: {
      required
    }
  },

  computed: {
    isValidDate() {
      return !this.$v.date.$invalid;
    },
    // isValidCultivo() {
    //   return !this.$v.cultivo.$invalid;
    // },
    // isValidEmbalaje() {
    //   return !this.$v.embalaje.$invalid;
    // },
    isValidCantidad() {
      return !this.$v.cantidad.$invalid;
    },
    isValidUbicacion() {
      return !this.$v.ubicacion.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateCombos();
    }
  },

  created() {
    this.$store.dispatch('getNanoid');
    const ubicacionTemplateRaiz = [
      this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->raiz_id",
              value: this.ubicacionRaizValue,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      })
    ];
    const ubicacionTemplateNoRaiz = [
      this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ],
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      })
    ];
    this.isLoadingPage = true;
    this.$store;

    const ubi = [this.$store.dispatch("customHTTP", { schema: "cultivos" })];

    if (this.ubicacionRaizValue) {
      ubi.push(...ubicacionTemplateRaiz);
    } else {
      ubi.push(...ubicacionTemplateNoRaiz);
    }

    if(this.folio){
      ubi.push(this.$store.dispatch("customDocumentoHTTP", {
        schema: "producciones",
        filter: {
          wherein: [
            {
              field: "payload->encabezado->ubicacion_raiz_id",
              value: [this.ubicacionRaizValue]
            }
          ],
          where: [
            {
              field: "folio",
              value: this.folio,
              operator: "="
            }
          ]
        },
        ["with-storage"] : ["*"]
      }))
    }
    Promise.all(ubi)
      .then(([cultivos, ubicaciones, item]) => {
        this.cultivos = cultivos.data.map(cultivo => {
          const variedad = cultivo.payload.variedad || ''
          return { value: cultivo.id, label: `${cultivo.payload.nombre} ${variedad}`};
        });
        this.cultivosAll = cultivos.data;
        this.ubicaciones = ubicaciones.data.map(ubicacion => {
          return { value: ubicacion.id, label: ubicacion.payload.nombre };
        });
        this.ubicacionesAll = ubicaciones.data;
        if(item){
          this.item = item.data[0];
          this.cultivo = this.cultivos.find(f=>f.value == this.item.payload.encabezado.cultivo_id);
          this.getEmbalaje()
          this.embalaje = this.embalajes.find(f=>f.value==this.item.payload.encabezado.embalaje);

          this.ubicacion = this.item.payload.encabezado.ubicacion_id;
          this.cantidad = this.item.payload.encabezado.cantidad;
          this.comentarios = this.item.payload.encabezado.comentarios
          this.nanoid = this.item.payload.encabezado.nanoid
          this.medias = this.item.payload.anexos;

          const newMult = this.item.payload.encabezado._relaciones.ubicacion
              .filter(ubi => ubi.id)
              .map(ubicacion => {
                return { value: ubicacion.id, label: ubicacion.payload.nombre };
              });
          this.multi = newMult;
          this.date = moment(this.item.payload.encabezado.fechahora,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
        }
      })
      .finally(() => (this.isLoadingPage = false));
  },

  methods: {
    closeModal(){
      this.successModal = false;
      if(this.folio){
        this.$router.push({ name: 'Produccion' });
      }
    },
    async pushMedia(files) {
      const arr = [];

      for (const v of files.map(async (m) => {
        // eslint-disable-next-line no-extra-boolean-cast
        if(!!m.media){
          return Promise.resolve({data:m,status:"success"})
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;

        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
    getEmbalaje() {
      if (this.cultivo) {
        const cultivoSelect = this.cultivosAll.find(
          cult => cult.id == this.cultivo.value
        );

        const embalajesNew = cultivoSelect.payload.embalajes.map(embalaje => {
          return {
            value: embalaje.nombre,
            label: embalaje.nombre,
            eq: Number(embalaje.equivalencia),
            type: embalaje.tipo ?? 'kilos'
          };
        });
        // this.filtrarUbicacion();
        this.embalajes = embalajesNew;
      } else {
        this.embalajes = [];
        this.multi = null;
        this.ubicaciones = this.ubicacionesAll.map(ubicacion => {
          return { value: ubicacion.id, label: ubicacion.payload.nombre };
        });
      }
    },
    filtrarUbicacion() {
      const cultSelect = this.cultivosAll.find(
        cultivo => cultivo.id == this.cultivo.value
      );

      const newUbi = this.ubicacionesAll.filter(
        ubi => ubi.payload.cultivo_id == cultSelect.id
      );

      this.ubicaciones = newUbi.map(ubicacion => {
        return { value: ubicacion.id, label: ubicacion.payload.nombre };
      });
    },
    async addProduccion() {
      this.validateProduccion();

      this.fetching = true
      this.isLoading = true;
      await (new Promise((res,)=>{
        const iter = setInterval(()=>{
          if(!this.fetching){
            this.error = ""
            clearInterval(iter)
            res()
          }
          debugger
        },1000)
      }))
      this.isLoading = false;
      if(this.error){
        this.successModal = false;
        return
      }
      if (this.isValidDate && this.isValidCantidad) {
        if (!this.cultivo) {
          this.error = "El campo cultivo es obligatorio";
          this.warningModal = true;
          return;
        }
        if (!this.embalaje) {
          this.error = "El campo embalaje es obligatorio";
          this.warningModal = true;
          return;
        }
        if (!this.multi) {
          this.error = "El campo ubicaciones es obligatorio";
          this.warningModal = true;
          return;
        }
        if (this.multi.length == 0) {
          this.error = "El campo ubicaciones es obligatorio";
          this.warningModal = true;
          return;
        }

        this.isLoading = true;
        let newDate = moment(this.date, "YYYY-MM-DD HH:mm:ss");
        // const numUbicaciones = this.multi.length;
        // const cantidadProrrateo = (
        //   Number(this.cantidad) / Number(numUbicaciones)
        // ).toFixed(2);

        const ubicacionValues = this.multi.map(ubicacion => ubicacion.value);

        const newProduction = {
          folio:this.folio,
          schema: "producciones",
          payload: {
            encabezado: {
              ...this.folio?{nanoid: this.nanoid}:{},
              ...this.folio?{cantidad_eq: this.embalaje.eq * Number(this.cantidad)}:{},
              fechahora: newDate.format("YYYY-MM-DD HH:mm:ss"),
              ubicaciones: ubicacionValues,
              cultivo_id: this.cultivo ? Number(this.cultivo.value) : 0,
              embalaje: this.embalaje ? this.embalaje.value : "",
              cantidad: Number(this.cantidad),
              peso: Number(this.peso),
              ubicacion_raiz_id: this.ubicacionRaiz
                ? this.ubicacionRaiz.value
                : null,
              comentarios: this.comentarios||'',
            },
            anexos: this.medias,
          }
        };

        // console.log(newProductions);

        this.$store
          .dispatch(
            this.folio?"customDocumentoRemplazarHTTP":"customDocumentoAddHTTP",
            newProduction
            //  {
            //    schema: "producciones",
            //    payload: {
            //     encabezado: {
            //       fechahora: newDate.toISOString().slice(0, -5),
            //       ubicacion_id: this.ubicacion,
            //       // cultivo_id: this.cultivo,
            //       embalaje: this.embalaje ? this.embalaje.value : "",
            //       cantidad: Number(this.cantidad)
            //     }
            //   }
            // }
          )
          .then(() => {
            // res.data.map(respuesta => {
            //   if (Object.prototype.hasOwnProperty.call(respuesta, "status")) {
            //     if (respuesta.status === "fail") {
            //       //catch
            //       this.error = respuesta.message;
            //       this.warningModal = true;
            //       return;
            //     }
            //   }

            //   //  respuesta.hasOwnProperty("status")
            // });
            // if (Object.prototype.hasOwnProperty.call(res.data[0], "status")) {
            //   if (res.data[0].status === "fail") {
            //     //catch
            //     this.error = res.data[0].message;
            //     this.warningModal = true;
            //     return;
            //   }
            // }
            this.currentAlertCounter = 6;
            // console.log(res.data);
            // this.$router.push({ name: "Produccion" });
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
            this.isLoading = false;
            return;
          })

          .finally(() => {
            this.isLoading = false;
            if (!this.warningModal) {
              this.successModal = true;
            }
          });
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateProduccion() {
      this.$v.date.$touch();
      // this.$v.cultivo.$touch();
      // this.$v.embalaje.$touch();
      this.$v.cantidad.$touch();
      this.$v.peso.$touch();
      this.$v.ubicacion.$touch();
      // this.$v.equivalencia_6oz.$touch();
    },
    updateCombos() {
      const ubicacionTemplateRaiz = [
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->raiz_id",
                value: this.ubicacionRaizValue,
                operator: "="
              },
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        })
      ];
      const ubicacionTemplateNoRaiz = [
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        })
      ];
      this.isLoadingPage = true;
      this.$store;

      const ubi = [];

      if (this.ubicacionRaizValue) {
        ubi.push(...ubicacionTemplateRaiz);
      } else {
        ubi.push(...ubicacionTemplateNoRaiz);
      }

      Promise.all(ubi)
        .then(([ubicaciones]) => {
          this.ubicaciones = ubicaciones.data.map(ubicacion => {
            return { value: ubicacion.id, label: ubicacion.payload.nombre };
          });
          this.ubicacionesAll = ubicaciones.data;
        })
        .finally(() => (this.isLoadingPage = false));
    },
    cleanMulti() {
      this.multi = [];
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
